import { Typography, useMediaQuery } from "@mui/material";
import { RdxInputStyles } from "./InputClasses";
import { TextField, Button, Box } from "@mui/material";
import clsx from "clsx";
import { Autocomplete } from "@mui/material";
import { ArrowDropDown, Clear } from "@mui/icons-material";
import { InputError, SelectFieldArrow } from "../Icons";
import { useEffect, useState } from "react";
import { Checkbox } from "@mui/material";
import { useDispatch, useSelector } from "src/store";
import { addressValidator } from "src/api/APIs";

const fullWidthBig = 425;
const fullWidthSmall = 340;
const widthMargin = 10;
let smallWindow = window.matchMedia("(max-width: 960px)");
const fullWidth = smallWindow.matches ? fullWidthSmall : fullWidthBig;

export const getWidth = (rate, takeMargin?) => {
  let resWidth = (fullWidth * rate) / 100;
  if (takeMargin) {
    resWidth = resWidth + widthMargin + 1;
  }
  return 756;
};

export const RdxTextField = ({
  input,
  label,
  meta,
  placeholder,
  customClass,
  required,
  additional,
  width,
  takeMargin,
  password,
  ...rest
}) => {
  // @ts-ignore
  if (!width) {
    width = 100;
  }
  let isError = Boolean(meta.touched && meta.error);
  const classes = RdxInputStyles({
    error: Boolean(meta.touched && meta.error),
    width: getWidth(width, takeMargin),
    rate: width,
    takeMargin,
    groupClass: "serAddress",
  });
  const smallSize = useMediaQuery("(max-width:960px)");
  return (
    <Box mt={4} className={classes.inputContainer}>
      <Typography ml={smallSize ? 4 : 6} sx={{ fontSize: smallSize ? 16 : 18 }}>
        {label}
      </Typography>
      <TextField
        autoComplete="off"
        // label={label}
        type={password && password.visible === "hidden" ? "password" : "text"}
        fullWidth
        size="small"
        className={clsx(
          classes.textField,
          input.value.length > 0 && [input.name]
        )}
        inputProps={{
          placeholder: placeholder,
          className: classes.inputProps,
          autocomplete: "new-password",
          form: {
            autocomplete: "off",
          },
        }}
        InputProps={{
          endAdornment: isError && (
            <Box className={classes.endAdornment}>
              <InputError />
            </Box>
          ),
        }}
        InputLabelProps={{
          style: {
            fontSize: "16px",
          },
        }}
        variant="outlined"
        error={isError}
        // helperText={meta.touched && meta.error}
        onBlur={input.onBlur}
        onChange={input.onChange}
        sx={{
          width: "100%",
        }}
        placeholder={placeholder}
        {...input}
        {...rest}
      />
      <style>{`
                .${input.name} label{
                    color: #FF7676 !important
                },
            `}</style>
    </Box>
  );
};

export const RdxAutocompleteField = ({
  input,
  label,
  meta,
  setDetails,
  placeholder,
  customClass,
  required,
  additional,
  width,
  takeMargin,
  defaultValue,
  options,
  ...rest
}) => {
  // @ts-ignore
  if (!width) {
    width = 100;
  }
  let isError = Boolean(meta.touched && meta.error);
  const [isOpen, setIsOpen] = useState(false);

  const classes = RdxInputStyles({
    error: isError,
    width: getWidth(width, takeMargin),
    rate: width,
    takeMargin,
    label: label,
    groupClass: "serAddress",
  });
  const smallSize = useMediaQuery("(max-width:960px)");
  return (
    <Box mt={4} className={`${classes.inputContainer} `}>
      <Typography ml={smallSize ? 4 : 6} sx={{ fontSize: smallSize ? 16 : 18 }}>
        {label}
      </Typography>
      <Autocomplete
        {...input}
        {...rest}
        options={options}
        sx={{ width: "100%", mb: "4px" }}
        value={input.value.value}
        autoComplete
        autoHighlight
        onOpen={() => setIsOpen(true)}
        onClose={() => setIsOpen(false)}
        defaultValue={defaultValue ? defaultValue : ""}
        disableClearable={input.value ? false : true}
        clearIcon={
          <Clear fontSize="small" color={isError ? "red" : "secondary"} />
        }
        popupIcon={<SelectFieldArrow isOpen={isOpen} error={isError} />}
        onChange={(event, newValue) => {
          //@ts-ignore
          newValue && input.onChange(newValue["value"]);
          setDetails(newValue);
        }}
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Typography fontSize={smallSize ? 16 : 18}>
              {option["label"]}{" "}
            </Typography>
          </li>
        )}
        renderInput={(params) => {
          return (
            <TextField
              autoComplete="off"
              error={Boolean(meta.touched && meta.error)}
              // helperText={meta.touched && meta.error}
              {...params}
              // label={label}
              placeholder={placeholder || ""}
              className={classes.textField}
              onBlur={input.onBlur}
              value={params.inputProps.value}
              inputProps={{
                ...params["inputProps"],
                placeholder: placeholder,
                className: classes.inputProps,
              }}
              InputProps={{
                ...params.InputProps,
                classes: { input: classes.autoInput },
                style: {
                  fontSize: smallSize ? 16 : 18,
                  padding: smallSize && "0px 12px",
                },
              }}
              InputLabelProps={{
                style: {
                  fontSize: "16px",
                  lineHeight: "18px",
                },
              }}
            // classes={{ root: classes.customTextField }}
            />
          );
        }}
      />
    </Box>
  );
};

export const AddressField = ({
  value,
  setValue,
  placeholder,
  width,
  takeMargin,
  defaultValue,
  handleSelect,
  ...rest
}) => {
  // @ts-ignore
  const smallSize = useMediaQuery("(max-width:960px)");
  const sm = useMediaQuery("(max-width:500px)");
  if (sm) {
    width = 100;
  }
  let isError = false;
  const [isOpen, setIsOpen] = useState(false);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(
    defaultValue?.value ?? ""
  );
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);
  const [reason, setReason] = useState("");

  const classes = RdxInputStyles({
    error: isError,
    width: getWidth(width, takeMargin),
    rate: width,
    takeMargin,
    groupClass: "serAddress",
  });

  const fetchAddress = async (val) => {
    try {
      if (val && reason === "input") {
        const res = await addressValidator(val);
        setOptions(res.data);
      }
    } catch (e) {
      console.log("Error :", e);
    }
  };

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearchTerm(inputValue);
    }, 500);

    return () => {
      clearTimeout(timerId);
    };
  }, [inputValue]);

  useEffect(() => {
    fetchAddress(debouncedSearchTerm);
  }, [debouncedSearchTerm]);
  return (
    <Box
      m={0}
      // sx={{ borderRadius: "10vw", backgroundColor: "#ededed" }}
      className={clsx(classes.inputContainer, classes.addressContainer)}
    >
      <Autocomplete
        {...rest}
        options={options}
        sx={{ width: "100%" }}
        autoComplete
        autoHighlight
        loading={debouncedSearchTerm.length}
        onOpen={() => setIsOpen(true)}
        onClose={() => setIsOpen(false)}
        // disableClearable={value ? false : true}
        clearIcon={
          <Clear fontSize="small" color={isError ? "red" : "secondary"} />
        }
        popupIcon={<SelectFieldArrow isOpen={isOpen} error={isError} />}
        value={debouncedSearchTerm}
        onChange={(e, newValue) => {
          newValue && setValue(newValue["value"]);
          handleSelect(newValue);
        }}
        inputValue={inputValue}
        onInputChange={(event, newInputValue, reason) => {
          setReason(reason);
          setInputValue(newInputValue);
        }}
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Typography fontSize={smallSize ? 16 : 18}>
              {option["label"]}{" "}
            </Typography>
          </li>
        )}
        renderInput={(params) => {
          return (
            <TextField
              // sx={{ borderRadius: "10vw", backgroundColor: "#ededed" }}
              autoComplete="off"
              // error={Boolean(meta.touched && meta.error)}
              // helperText={meta.touched && meta.error}
              {...params}
              // label={label}
              placeholder={placeholder || ""}
              className={clsx(classes.textField, classes.addressTextField)}
              value={params.inputProps.value}
              inputProps={{
                ...params["inputProps"],
                placeholder: placeholder,
                className: clsx(
                  classes.inputProps,
                  !smallSize && classes.addressInputProps
                ),
              }}
              InputProps={{
                ...params.InputProps,
                classes: { input: classes.autoInput },
                style: {
                  fontSize: smallSize ? 16 : 18,
                  padding: smallSize && "0px 12px",
                  borderRadius: "10vw",
                  backgroundColor: "#ededed",
                },
              }}
              InputLabelProps={{
                style: {
                  fontSize: "16px",
                  lineHeight: "18px",
                },
              }}
            // classes={{ root: classes.customTextField }}
            />
          );
        }}
      />
    </Box>
  );
};

export const RdxCheckBox = ({
  input,
  children,
  meta,
  placeholder,
  customClass,
  required,
  additional,
  width,
  takeMargin,
  ...rest
}) => {
  // const theme = useTheme();
  let isError = Boolean(meta.touched && meta.error);
  const classes = RdxInputStyles({
    error: Boolean(meta.touched && meta.error),
  });
  return (
    <Box className={clsx(classes.flexBox, classes.checkboxContainer)}>
      <Checkbox
        style={{
          color: input.value ? "#009A88" : isError ? "#F22824" : "#C1C1C1",
        }}
        {...input}
        {...rest}
        checked={input.value}
      />
      <Typography
        color={isError ? "error" : "#6D6D6D"}
        align="left"
        style={{ fontSize: "14px" }}
        className={classes.textfieldLabel}
      >
        {children}
      </Typography>
    </Box>
  );
};

export const SubmitButton = ({ children, ...props }) => {
  const classes = RdxInputStyles();
  return (
    <Button
      {...props}
      variant="contained"
      color="secondary"
      className={classes.submitButton}
    >
      {children}
    </Button>
  );
};

export const CancelButton = ({ children, ...props }) => {
  const classes = RdxInputStyles();
  return (
    <Button
      {...props}
      color="secondary"
      variant="outlined"
      className={classes.cancelButton}
    >
      {children}
    </Button>
  );
};
